module.exports = __webpack_public_path__ + "static/1-4e5d4a16337554e26c87516a585b6e86.jpg";